const binding = { modules: {}, dataActions: {} };

    const registerActionId = (actionPath) => {
        if (binding.dataActions[actionPath] &&
            binding.dataActions[actionPath].default &&
            binding.dataActions[actionPath].default.prototype &&
            binding.dataActions[actionPath].default.prototype.id) {
            binding.dataActions[binding.dataActions[actionPath].default.prototype.id] = binding.dataActions[actionPath];
        } else {
            Object.keys(binding.dataActions[actionPath] || {}).forEach(exportName => {
                if (binding.dataActions[actionPath][exportName] &&
                    binding.dataActions[actionPath][exportName].prototype &&
                    binding.dataActions[actionPath][exportName].prototype.Action) {
                    binding.dataActions[binding.dataActions[actionPath][exportName].prototype.id] = binding.dataActions[actionPath][exportName];
                }
            })
        }
    };

    const registerSanitizedActionPath = (sanitizedActionPath, dataAction) => {
        if (process.env.NODE_ENV === 'development') {
            if (!dataAction.default) {
                throw new Error('Data action path does not have a default export');
            }
            if (!(dataAction.default.prototype.id && binding.dataActions[dataAction.default.prototype.id]) || !binding.dataActions[sanitizedActionPath]) {
                binding.dataActions[sanitizedActionPath] = dataAction;
            }
        } else {
            binding.dataActions[sanitizedActionPath] = dataAction;
            if (!binding.dataActions[sanitizedActionPath].default) {
                throw new Error('Data action path ' + sanitizedActionPath + ' does not have a default export');
            }
            binding.dataActions[sanitizedActionPath].default.prototype.RegistrationId = sanitizedActionPath;
            if (binding.dataActions[sanitizedActionPath].default.prototype.id) {
                binding.dataActions[binding.dataActions[sanitizedActionPath].default.prototype.id] = sanitizedActionPath;
            }
        }
    };
    

        {   
            const actionPath = 'actions/GetCustomerAddress.action';
            binding.dataActions[actionPath] = require('partner/actions/GetCustomerAddress.action');
            registerActionId(actionPath);
        }

        {   
            const actionPath = 'actions/GetProductsByPartNumber.action';
            binding.dataActions[actionPath] = require('partner/actions/GetProductsByPartNumber.action');
            registerActionId(actionPath);
        }

        {   
            const actionPath = 'actions/addproductlistlines.action';
            binding.dataActions[actionPath] = require('partner/actions/addproductlistlines.action');
            registerActionId(actionPath);
        }

        {   
            const actionPath = 'actions/createAddProductListLines.action';
            binding.dataActions[actionPath] = require('partner/actions/createAddProductListLines.action');
            registerActionId(actionPath);
        }

        {   
            const actionPath = 'actions/get-full-products-by-collection.override.action';
            binding.dataActions[actionPath] = require('partner/actions/get-full-products-by-collection.override.action');
            registerActionId(actionPath);
        }

        {   
            const actionPath = 'actions/get-invoices.action';
            binding.dataActions[actionPath] = require('partner/actions/get-invoices.action');
            registerActionId(actionPath);
        }

        {   
            const actionPath = 'actions/get-product-active-prices.action';
            binding.dataActions[actionPath] = require('partner/actions/get-product-active-prices.action');
            registerActionId(actionPath);
        }

        {   
            const actionPath = 'actions/get-product-attributes-cartlines.action';
            binding.dataActions[actionPath] = require('partner/actions/get-product-attributes-cartlines.action');
            registerActionId(actionPath);
        }

        {   
            const actionPath = 'actions/get-products.action';
            binding.dataActions[actionPath] = require('partner/actions/get-products.action');
            registerActionId(actionPath);
        }

        {   
            const actionPath = 'actions/getCustomer.action';
            binding.dataActions[actionPath] = require('partner/actions/getCustomer.action');
            registerActionId(actionPath);
        }

        {   
            const actionPath = 'actions/getStateCity.action';
            binding.dataActions[actionPath] = require('partner/actions/getStateCity.action');
            registerActionId(actionPath);
        }

        {   
            const actionPath = 'actions/payment-state-share.action';
            binding.dataActions[actionPath] = require('partner/actions/payment-state-share.action');
            registerActionId(actionPath);
        }

        {   
            const actionPath = 'actions/searchOrderHistoryByPO.action';
            binding.dataActions[actionPath] = require('partner/actions/searchOrderHistoryByPO.action');
            registerActionId(actionPath);
        }

        
    window.__bindings__ = window.__bindings__ || {};
    window.__bindings__.modules = {
        ...window.__bindings__.modules || {},
        ...binding.modules
    };
    
        window.__bindings__.packageDataActions = {};
        window.__bindings__.packageDataActions['__local__'] = {
            ...binding.dataActions
        };